import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';
import { Input } from '@/components/ui/input';
import { useChatWidgetStore } from '@/stores/chatWidgetStore';
import { useLocales } from '@/locales';
import { cn } from '@/lib/utils';

export default function ContactForm() {
  const { translate } = useLocales();
  const contact = useChatWidgetStore(state => state.contact);
  const setContact = useChatWidgetStore(state => state.setContact);
  const [open, setOpen] = useState(Boolean(contact));

  const update = (field, value) => {
    setContact({ ...(contact || {}), [field]: value });
  };

  return (
    <Collapsible
      open={open}
      onOpenChange={setOpen}
      className="border-t border-gray-100"
    >
      <CollapsibleTrigger className="flex w-full items-center justify-between px-3 py-2 text-xs text-gray-600 hover:bg-gray-50">
        <span>{translate('chat_contact_toggle')}</span>
        <ChevronDown
          className={cn('h-3 w-3 transition-transform', open && 'rotate-180')}
        />
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="flex flex-col gap-2 px-3 pb-2">
          <Input
            value={contact?.name || ''}
            onChange={e => update('name', e.target.value)}
            placeholder={translate('chat_contact_name')}
            className="h-8 text-xs"
          />
          <Input
            value={contact?.phoneEmail || ''}
            onChange={e => update('phoneEmail', e.target.value)}
            placeholder={translate('chat_contact_phone_email')}
            className="h-8 text-xs"
          />
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}
